const header = {
  systemTitle: 'Hệ thống điều khiển ép phun tích hợp',
  logoAlt: 'Logo',
  notice: 'Thông báo',
  noticeEmpty: 'Không có thông báo',
  noticeCount: '{count}',
  noticeBadge: {
    urgent: 'Khẩn cấp',
    update: 'Cập nhật',
    notice: 'Thông báo',
    general: 'Chung',
  },
  alarmStatus: 'Trạng thái cảnh báo',
  alarmCount: '{count}',
  alarmLoading: 'Đang tải cảnh báo...',
  alarmNone: 'Không có cảnh báo',
  noticeAll: 'Xem tất cả thông báo',
  noticeViews: '{count} lượt xem',
  bell: 'Trung tâm cảnh báo',
  ticker: {
    count: '{sev} {count}',
    prev: 'Cảnh báo trước',
    next: 'Cảnh báo sau',
    list: 'Mở trung tâm cảnh báo',
    openDetail: 'Xem chi tiết cảnh báo',
  },
  toast: {
    detail: 'Chi tiết thiết bị',
    ack: 'Xác nhận',
  },
  center: {
    title: 'Trung tâm cảnh báo',
    unread: 'Chưa xác nhận {count}',
    subtitle: 'Toàn bộ cảnh báo · nhấn hàng để xem chi tiết',
    all: 'Tất cả {count}',
    unreadChip: 'Chưa xác nhận {count}',
    severityAll: 'Mọi mức độ',
    ackAll: 'Xác nhận tất cả',
    history: 'Xem toàn bộ lịch sử',
    acked: 'Đã xác nhận',
    empty: 'Không có cảnh báo',
    ackNote: 'Trạng thái xác nhận·tắt tiếng chỉ lưu trên trình duyệt này (chưa có API máy chủ)',
  },
  detail: {
    position: '{sev} {i}/{n}',
    prev: 'Trước',
    next: 'Cảnh báo sau',
    list: 'Toàn bộ',
    cause: 'Nguyên nhân',
    codeLabel: 'Mã cảnh báo {code}',
    typeLabel: 'Loại {type}',
    indicators: 'Chỉ số lúc phát sinh',
    indicatorNote: 'Theo shot gần nhất (không phải giá trị lúc cảnh báo)',
    maxPressure: 'Áp ép tối đa',
    cushion: 'Vị trí đệm',
    cycleTime: 'Thời gian chu kỳ',
    quick: 'Thao tác nhanh',
    ack: 'Xác nhận (ACK)',
    acked: 'Đã xác nhận',
    mute: 'Tắt tiếng 30 phút',
    muted: 'Đang tắt tiếng đến {time}',
    goEquipment: 'Đến chi tiết thiết bị · tab cảnh báo',
    askAi: 'Hỏi AI nguyên nhân',
    alarmId: 'ID cảnh báo {id}',
    history: 'Xem toàn bộ lịch sử',
    timeAgoAt: '{time} ({ago})',
    askQuestion: 'Cho biết nguyên nhân và cách xử lý cảnh báo "{message}" (mã {code}) trên {equipment}',
  },
  ai: {
    fab: 'Hỏi',
    title: 'Trợ lý AI',
    openFull: 'Mở phân tích đầy đủ',
    context: 'Bối cảnh',
    empty: 'Hãy hỏi bất cứ điều gì về dữ liệu hiện trường',
    suggestionsTitle: 'Câu hỏi gợi ý (màn hình này)',
    q1: 'Máy nào có nhiều cảnh báo nhất trong 24 giờ qua?',
    q2: 'Máy nào có tỷ lệ lỗi cao nhất hôm nay?',
    q3: 'Hiện có bao nhiêu máy đang chạy?',
    placeholder: 'Hỏi bằng thuật ngữ hiện trường…',
    send: 'Gửi',
    thinking: 'Đang phân tích…',
    failed: 'Không kết nối được dịch vụ AI',
    noAnswer: 'Không tạo được câu trả lời',
    newChat: 'Trò chuyện mới',
    newChatHint: 'Xóa cuộc trò chuyện này và bắt đầu lại',
  },
  collection: {
    loading: 'Đang kiểm tra...',
    title: 'Trạng thái thu thập dữ liệu',
    factoryCount: '{count} nhà máy',
    statusNoEquipment: 'Không có thiết bị',
    stoppedBadge: '{count} máy ngừng',
    allNormal: 'Dữ liệu đang được thu thập bình thường từ tất cả thiết bị',
    empty: 'Chưa đăng ký nhà máy',
    countRunning: 'Đang chạy',
    countIdle: 'Chờ',
    countStopped: 'Ngừng',
    neverCollected: 'Chưa từng thu thập',
    elapsedMin: '{n} phút trước',
    elapsedHour: '{n} giờ trước',
    elapsedDay: '{n} ngày trước',
  },
};

export default header;
